
export default class Name {
  static isValid(name){
    let regex = /^[\p{L}' -]+$/u;
    return regex.test(String(name).trim());
  }
}
